export const FILTERS_WRAPPER = 'filters-wrapper';
export const FILTERS_CONTENT = 'filters-content';
export const FILTER_BUTTON = 'filter-button';
export const FILTER_OFFERS_KEY = 'qualifiers';
export const FILTER_NUMBER_GUEST_KEY = 'numberOfGuests';
export const FILTER_CUSTOM = 'custom';
